import {axiosUtil} from "../../../../utils/axios_util";

const XNumberManageApi = {
    //分页查询X池号码
    manageXPoolNumberPage(data:powerSearchData) {
        return axiosUtil({
            url: '/middleNumber/manager/page',
            method: 'post',
            data,
            params: {
                page: data.page,
                size: data.size
            }
        })
    },
    //批量新增 X池号码预览
    addPreview(xpoolNo:string,data: any) {
        return axiosUtil({
            url: `/middleNumber/manager/batch/add/preview/${xpoolNo}`,
            method: 'post',
            headers: { 'Content-Type': 'multipart/form-data' },
            data
        })
    },
    //预览数据分页查询
    previewPage(data:powerSearchData) {
        return axiosUtil({
            url: '/middleNumber/manager/batch/preview/page',
            method: 'post',
            data,
            params: {
                page: data.page,
                size: data.size
            }
        })
    },
    //提交到飞书审核 ， 批量新增X池号码预览
    addApproval(batchNumber:string,data: any) {
        return axiosUtil({
            url: `/middleNumber/manager/batch/add/approval/${batchNumber}`,
            method: 'post',
            headers: { 'Content-Type': 'multipart/form-data' },
            data
        })
    },
    //预览数据错误类型统计
    previewCount(data: string) {
        return axiosUtil({
            url: `/middleNumber/manager/batch/preview/count/${data}`,
            method: 'post',
            data
        })
    },
    //X池号码数据统计
    statistics(data: any) {
        return axiosUtil({
            url: `/middleNumber/manager/statistics`,
            method: 'post',
            data
        })
    },
    //错误数据导出
    exportError(data:any) {
        return axiosUtil({
            url: `/middleNumber/manager/export/error`,
            method: 'post',
            // headers: { 'Content-Type': 'application/json' },
            responseType: 'blob',
            data
        })
    },
    //获取报备书的临时下载路径
    getPreSignedUrl(data: any) {
        return axiosUtil({
            url: `/middleNumber/manager/report/getPreSignedUrl`,
            method: 'post',
            data
        })
    },
    //查询当前账户全部x池
    getAllXPool(data:any) {
        return axiosUtil({
            url: `/middleNumberPool/manager/findAll/${data}`,
            method: 'post',
        })
    },
}

export default XNumberManageApi
